import api from "./base";

export const checkVoucher = (code) => {
  return api.post(`/voucher/${code}`, {
    // headers: { Authorization: `Bearer ${token}` },
  });
};
